import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  background-color: #f8fafc;
  text-align: center;
`

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  flex-shrink: 0;
`

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #283845;
  line-height: 130%;
`

export const Description = styled.p`
  font-size: 14px;
  color: #64748b;
  max-width: 300px;
`

export const ReloadButton = styled.button`
  margin-top: 12px;
  height: 55px;
  padding: 16px 32px;
  border-radius: 32px;
  border: none;
  background-color: #445d74;
  color: #fff;
  font-size: 16px;
  font-weight: 590;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }

  &:active {
    opacity: 0.7;
  }
`
